import config from 'config';

let logger;

if (typeof window === 'undefined') {

  // Must be dynamically required as import will throw an error in browser
  // winston is not included in browser bundle with webpack
  const winston = require('winston');

  const transport = config.isProduction ? new (winston.transports.Console)({ json: true,  level: 'info', stringify: true })
                                        : new (winston.transports.Console)({ json: true,  level: 'debug' });

  logger = new winston.Logger({
    level: 'info',
    transports: [
      transport
    ]
  });

} else {

  // No implementation needed for these as it will be browser only.
  logger = {
    error: () => {},
    warn: () => {},
    info: () => {},
    debug: () => {},
    trace: () => {}
  };

}

export default logger;



// WEBPACK FOOTER //
// ./logger.js